import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createExperience = async (data) => {
  console.log(data);
  try {
    let res = await Api.post("/experience", data);
    return res?.data;
  } catch (e) {
    console.log(e);
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getExperienceDataLocation = async (query) => {
  try {
    let res = await Api.get("/experience/location", {
      params: query,
      headers:{
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    });
  
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getExperienceData = async (query) => {
  try {
    let res = await Api.get("/experience", {
      params: query,
      headers:{
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    });
  
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteExperienceData = async (id) => {
  try {
    let res = await Api.delete("/experience/" + id);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateExperienceData = async (id, data) => {
  try {
    let res = await Api.patch("/experience/" + id, data);
  
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const cleanupExperienceImages = async (fileNames) => {
  if (!fileNames || fileNames.length === 0) return;
  try {
    await Api.post("/experience/cleanup-images", { fileNames });
  } catch (e) {
    // Best-effort cleanup — a failure here shouldn't block the save that already succeeded.
  }
};

export const updatePosition = async(id,pos)=>{
  try {
    let res = await Api.patch("/experience/relocate-position", {id, relocatePosition: pos});
  
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
}
